import { ActionTree }                                 from 'vuex';
import i18n                                           from '@/i18n';
import { RootState }                                  from '@/store/store.types';
import { State }                                      from '@/views/changelog-settings/changelog-settings.types';
import { Notification }                               from '@/components/notification/notification';
import { getChangelogSettings, putChangelogSettings } from '@/views/changelog-settings/services/changelog-settings.service';

const actions: ActionTree<State, RootState> = {
  async getChangelogSettings({ commit }): Promise<void> {
    try {
      commit('setSettingsLoading', true);
      const { data }: { data: { systemAutoAccept: boolean; userAutoAccept: boolean } } = await getChangelogSettings();
      commit('setUserChangelogSettings', data.userAutoAccept);
      commit('setSystemChangelogSettings', data.systemAutoAccept);
    } catch (e) {
      Notification.error(
        i18n.t('vChangelogSettings.notification.error.title') as string,
        i18n.t('vChangelogSettings.notification.error.getSettings') as string,
      );
      throw e;
    } finally {
      commit('setSettingsLoading', false);
    }
  },
  async putChangelogSettings({ commit }, payload: { systemAutoAcceptEnabled: boolean; userAutoAcceptEnabled: boolean }): Promise<void> {
    try {
      commit('setSettingsLoading', true);
      await putChangelogSettings(payload);
      Notification.success(
        i18n.t('vChangelogSettings.notification.success.title') as string,
        i18n.t('vChangelogSettings.notification.success.updateSettings') as string,
      );
    } catch (e) {
      Notification.error(
        i18n.t('vChangelogSettings.notification.error.title') as string,
        i18n.t(e.response.data.reason) as string,
      );
      throw e;
    } finally {
      commit('setSettingsLoading', false);
    }
  },
};

export default actions;
